import React from 'react'
import { Outlet } from '@remix-run/react'
import Footer from '~/components/Footer'
import Nav from '~/components/Nav'

const _layout = () => {
  return (
    <>
      <Nav className="border-b border-black/10" />
      <Outlet />
      <Footer />
    </>
  )
}

export default _layout
